<template>
  <div>
    <slot :open-modal="openModal">
      <b-button
        v-ripple.400="'var(--hdg-ripple-primary)'"
        variant="outline-primary"
        size="sm"
        @click="openModal"
      >
        <feather-icon
          icon="RefreshCwIcon"
          class="mr-25"
        />
        {{ $t('สรุปยอดอีกครั้ง') }}
      </b-button>
    </slot>

    <recalculate-summary-modal
      v-model="showModal"
      :selected-month="selectedMonth"
      @success="handleSuccess"
    />
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import RecalculateSummaryModal from './RecalculateSummaryModal.vue'

export default {
  components: {
    BButton,
    RecalculateSummaryModal,
  },
  directives: {
    Ripple,
  },
  props: {
    selectedMonth: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
    }
  },
  methods: {
    openModal() {
      this.showModal = true
    },
    handleSuccess(data) {
      this.$emit('reload', data)
    },
  },
}
</script>
